  <div class="preview-backdrop" *ngIf="view.previewOpen && view.currentPreviewItem as previewItem" (click)="view.closePreview()" role="dialog" aria-modal="true">
    <div class="preview" (click)="$event.stopPropagation()">
      <div class="preview-header">
        <button class="icon-action" type="button" (click)="view.prevPreview()" [disabled]="view.previewIndex===0" [attr.aria-label]="view.translate('common.prev')">
          <mat-icon aria-hidden="true">chevron_left</mat-icon>
        </button>
        <div class="preview-title">
          <mat-icon class="doc-type-icon" [ngClass]="view.getItemIconClass(previewItem)">{{ view.getItemIcon(previewItem) }}</mat-icon>
          <span>{{ view.displayName(previewItem.name) }}</span>
        </div>
        <button class="icon-action" type="button" (click)="view.nextPreview()" [disabled]="view.previewIndex===view.visibleItems.length-1" [attr.aria-label]="view.translate('common.next')">
          <mat-icon aria-hidden="true">chevron_right</mat-icon>
        </button>
        <button class="icon-action" type="button" (click)="view.closePreview()" [attr.aria-label]="view.translate('common.close')">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>

      <div class="preview-body">
        <ng-container *ngIf="view.getPreviewError(previewItem) as error; else previewContent">
          <div class="preview-status error">
            <mat-icon aria-hidden="true">visibility_off</mat-icon>
            <span>{{ error }}</span>
          </div>
        </ng-container>

        <ng-template #previewContent>
          <div class="preview-status" *ngIf="view.isPreviewLoading(previewItem)">
            <div class="spinner" aria-hidden="true"></div>
            <span>{{ view.translate('drive.preview.loading') || 'Cargando vista previa...' }}</span>
          </div>

          <ng-container *ngIf="!view.isPreviewLoading(previewItem)">
            <ng-container *ngIf="view.isTextPreview(previewItem); else mediaPreview">
              <div class="text-preview" *ngIf="view.getPreviewText(previewItem) as previewText; else previewPending">
                <pre>{{ previewText }}</pre>
              </div>
            </ng-container>

            <ng-template #mediaPreview>
              <img *ngIf="previewItem.type === 'image' && previewItem.previewUrl" [src]="previewItem.previewUrl" [alt]="previewItem.name" class="preview-media" />
              <video *ngIf="previewItem.type === 'video' && previewItem.previewUrl" class="preview-media" controls>
                <source [src]="previewItem.previewUrl" />
              </video>
              <ng-container *ngIf="view.isFramePreview(previewItem)">
                <iframe *ngIf="view.getPreviewSafeUrl(previewItem) as frameUrl" [src]="frameUrl" [attr.title]="previewItem.name"></iframe>
              </ng-container>
              <div class="preview-status" *ngIf="!previewItem.previewUrl && !view.getPreviewSafeUrl(previewItem)">
                <mat-icon aria-hidden="true">hourglass_empty</mat-icon>
                <span>{{ view.translate('drive.preview.loading') || 'Cargando vista previa...' }}</span>
              </div>
              <div class="preview-status" *ngIf="previewItem.type !== 'image' && previewItem.type !== 'video' && !view.isFramePreview(previewItem)">
                <mat-icon aria-hidden="true">block</mat-icon>
                <span>{{ view.translate('drive.preview.not_available') }}</span>
              </div>
            </ng-template>
          </ng-container>
        </ng-template>

        <ng-template #previewPending>
          <div class="preview-status">
            <mat-icon aria-hidden="true">hourglass_empty</mat-icon>
            <span>{{ view.translate('drive.preview.loading') || 'Cargando vista previa...' }}</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="refresh-overlay" *ngIf="view.isRefreshingTree" aria-live="polite" aria-busy="true">
    <div class="spinner" role="status" aria-label="loading"></div>
    <div class="label">{{ view.translate('drive.refreshing') || 'Actualizando...' }}</div>
  </div>
